import * as React from "react"
import * as styles from "./styles.module.scss"
import Review from "../Review"
import ReviewRatings from "../ReviewRatings"

const ReviewsHomepage: React.FC = () => {
  return (
    <section className={styles.reviews}>
      <div className={styles.header}>
        <h3 className={styles.heading}>What our customers say</h3>
        <p className={styles.subhead}>
          Thousands of Americans have already used Better to get a mortgage
        </p>
      </div>
      <div className={styles.ratings}>
        <ReviewRatings />
      </div>
      <div className={styles.timeline}>
        <Review
          tapEnabled={true}
          author="Will H"
          info="Refinance in Matthews, NC"
          text={`Hands down the best experience I've ever had with a lender. Smart, efficient, accurate, cost effective. Will absolutely be using them again.`}
          url="https://www.google.com/search?q=better%20mortgage&rct=j#lrd=0x89c2598fbf38430d:0x67eb60959b6e3d79,1,"
        />
        <Review
          tapEnabled={true}
          author="Froilan R"
          info="Purchase in San Diego, CA"
          text={`My real estate agent was a bit skeptical at first because she's always been a brick and mortar type, but like me, she was also pleasantly surprised. From the pre approval letter to closing, nothing but positive things out of Better Mortgage, truly lived up to its name.`}
          url="https://www.google.com/search?q=better%20mortgage&rct=j#lrd=0x89c2598fbf38430d:0x67eb60959b6e3d79,1,"
        />
        <Review
          tapEnabled={true}
          author="Maria C"
          info="Refinance in Chicago, IL"
          text="Best Refi Experience Ever: I have gone through the refi process several times and this was by far the fastest and best process ever. I also work in the mortgage industry and this is a game changer. I would definitely recommend this company to anyone looking for a mortgage."
          url="https://www.google.com/search?q=better%20mortgage&rct=j#lrd=0x89c2598fbf38430d:0x67eb60959b6e3d79,1,"
        />
      </div>
    </section>
  )
}

export default ReviewsHomepage
